query DateCalcTermDays($days: Int!, $startDate: Date!) {
  dateCalcTermDays(days: $days, startDate: $startDate)
}
